// firebaseConfig.jsx
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDKskmS33ZpwVJME6SnOKPO_6QnsX55stQ",
  authDomain: "zeeshopzone.firebaseapp.com",
  databaseURL: "https://zeeshopzone-default-rtdb.firebaseio.com",
  projectId: "zeeshopzone",
  storageBucket: "zeeshopzone.firebasestorage.app",
  messagingSenderId: "1088880533324",
  appId: "1:1088880533324:web:b8df0d90d317abd539f9e9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const db = getDatabase(app);
const auth = getAuth(app);
const storage = getStorage(app); // Initialize Firebase storage

export { db, auth, storage };
